<template>
  <el-table-column
    prop="supplier_order.receipt_number"
    sortable="custom"
    label="Kapcsolódó beszállítói megrendelés"
    show-overflow-tooltip
    min-width="290"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.supplier_order_id"
        style="display: inline-block;"
      >
        <receipt-link
            v-if="scope.row.supplier_order_receipt_number"
            :id="scope.row.supplier_order_id"
            :label="scope.row.supplier_order_receipt_number"
            icon="printer"
            type="supplierOrder"
        />
      </div>
      <el-tag v-else size="small" type="warning">Nincs kapcsolódó megrendelés</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  import ReceiptLink from '../../../utils/ReceiptLink';
  export default {
    components: {
      ReceiptLink,
    },
    propName: 'supplier_order.receipt_number',
  };
</script>
